module.exports = __webpack_public_path__ + "static/media/youzan.9164683c.png";